(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hero-banner__track');
      this.slides = Array.from(this.querySelectorAll('.hero-banner__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevBtn = this.querySelector('.hero-banner__arrow--prev');
      this.nextBtn = this.querySelector('.hero-banner__arrow--next');
      this.isFade = this.classList.contains('hero-banner--fade');
      this.total = this.slides.length;
      this.index = 0;
      this.timer = null;

      if (this.total <= 1) return;

      if (this.isFade) this.slides[0].classList.add('is-active');
      this.bindEvents();
      this.startAutoplay();
    }

    goTo(n, transition = true) {
      const prev = this.index;
      this.index = ((n % this.total) + this.total) % this.total;

      if (this.isFade) {
        this.slides[prev].classList.remove('is-active');
        this.slides[this.index].classList.add('is-active');
      } else {
        if (!transition) {
          this.track.style.transition = 'none';
          this.track.style.transform = `translateX(${-this.index * 100}%)`;
          requestAnimationFrame(() => requestAnimationFrame(() => { this.track.style.transition = ''; }));
        } else {
          this.track.style.transform = `translateX(${-this.index * 100}%)`;
        }
      }

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('hero-banner__dot--active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => { this.stopAutoplay(); this.goTo(this.index - 1); this.startAutoplay(); });
      this.nextBtn?.addEventListener('click', () => { this.stopAutoplay(); this.goTo(this.index + 1); this.startAutoplay(); });

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this.stopAutoplay();
          this.goTo(Number(dot.dataset.dot));
          this.startAutoplay();
        });
      });

      this.addEventListener('keydown', ({ key }) => {
        if (key === 'ArrowLeft') { this.stopAutoplay(); this.goTo(this.index - 1); this.startAutoplay(); }
        if (key === 'ArrowRight') { this.stopAutoplay(); this.goTo(this.index + 1); this.startAutoplay(); }
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      const speed = Number(this.dataset.autoplaySpeed) || 5000;
      this.stopAutoplay();
      this.timer = setInterval(() => this.goTo(this.index + 1), speed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('hero-banner')) {
    customElements.define('hero-banner', HeroBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
